import { render } from "./Table.vue?vue&type=template&id=ff35974a&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=ff35974a&lang=css"
import "./Table.vue?vue&type=style&index=1&id=ff35974a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff35974a"]])

export default __exports__